<template>
    <div class="tw-tablet-profile">
        <div class="tw-tablet-user">
            <img id="user-head">
            <span>
                <h3 style="margin:5px 0px 5px 10px;color: #606266;">
                    {{user.user_name}}
                    <el-link href="#" @click.prevent="onEditUserName()" :underline="false" style="margin:0 0 5px 5px; font-size:20px;" icon="el-icon-edit-outline"></el-link>
                </h3>
                <p style="margin:5px 0px 5px 10px;color: #909399;">{{user.phone}}</p>
            </span>
            <div class="tw-tablet-options">
                <el-button v-if="user.bind_wx === false" type="success" @click="onBindingWeiXin">绑定微信</el-button>
                <el-button v-if="user.bind_wx === true" type="warning" @click="onUnbindWeiXin">解绑微信</el-button>
                <el-button type="danger" @click="onCloseAccount">注销</el-button>
            </div>
        </div>
        <div v-show="showBindBox" class="tw-tablet-binding-weixin" @click="showBindBox = false">
            <img ref="refQrcode" src="../../assets/logo.png" alt="">
            <div>请使用微信扫描二维码绑定</div>
        </div>
    </div>
</template>

<script>
import { onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'

import httpService from '../../services/http.service'
import eventBus from '../../utils/event-bus'

export default {
    name: "tw-tablet-profile",
    setup() {
        const router = useRouter()

        const user = reactive({})
        httpService.get('user-info').then(result => {
            Object.assign(user, result)
        })
        const showBindBox = ref(false)
        const refQrcode = ref(null)

        const createObjectURL = function (object) {
            return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object)
        }

        const onBindingWeiXin = function() {
            httpService.get('binding-weixin', {}, 'blob').then(blob => {
                refQrcode.value.src = createObjectURL(blob)
                showBindBox.value = true
            }).catch(err => {
                ElMessage.info({
                    showClose: true,
                    message: err.message
                })
            })
        }

        const onUnbindWeiXin = function() {
            ElMessageBox.confirm('解绑微信后将不能使用微信扫码登录及相关通知，确定要解除绑定吗？', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                httpService.put('unbind-weixin').then(() => {
                    user.bind_wx = false
                    ElMessage.info({
                        showClose: true,
                        message: '已解除绑定微信'
                    })
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }).catch(() => {

            })
        }

        const onEditUserName = function() {
            ElMessageBox.prompt('请输入新的用户名称', '重命名', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: user.user_name
            }).then(({ value }) => {
                if (value) {
                    httpService.put('user-info', {}, { user_name: value }).then(() => {
                        user.user_name = value
                    }).catch(err => {
                        ElMessage.info({
                            showClose: true,
                            message: err.message
                        })
                    })
                } else {
                    ElMessage.info({
                        showClose: true,
                        message: `未输入任何内容，放弃本次修改用户名称`
                    })
                }
            })
        }

        const onCloseAccount = function() {
            ElMessageBox.confirm('用户注销后将从本账套中移除，需要管理员重新添加后才可以登录，您确定要注销吗？', '提示信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                httpService.delete('remove-sob').then(() => {
                    // 注销后返回到登录界面
                    router.push({ name: 'login' })
                }).catch(err => {
                    ElMessage.info({
                        showClose: true,
                        message: err.message
                    })
                })
            }).catch(() => {

            })
        }

        const onWebSocketEvent = function(params) {
            if (params.type === 'bindingWeixin') {
                if (params.result.status === '200') {
                    // 绑定成功后改变绑定状态
                    user.bind_wx = true
                    // 关闭二维码
                    showBindBox.value = false
                }

                // 不管成功与否都要显示信息
                ElMessage.info({
                    showClose: true,
                    message: params.result.message
                })
            }
        }

        onMounted(() => {
            eventBus.on('SYSTEM_WEBSOCKET_EVENT', onWebSocketEvent)
        })

        onUnmounted(() => {
            eventBus.off('SYSTEM_WEBSOCKET_EVENT', onWebSocketEvent)
        })

        return {
            user, showBindBox, refQrcode, onEditUserName,
            onBindingWeiXin, onUnbindWeiXin, onCloseAccount
        }
    }
}
</script>

<style scoped>
.tw-tablet-profile {
    background-color: white;
    height: calc(100vh - 80px);
    padding: 10px;
}

.tw-tablet-user {
    background-color: #f2f2f2;
    border-radius: 5px;
    padding: 10px;
    display: flex;
}

#user-head {
    border-radius: 30px;
    width: 60px;
    height: 60px;
    content: url(../../assets/img/head_boy.png);
}

.tw-tablet-options {
    margin: auto 15px auto auto;
}

.tw-tablet-binding-weixin {
    width: 100%;
    top: 50%;
    left: 50%;
    text-align: center;
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 50000;
}
</style>